import React from 'react'
import BackgroundElementImg from './BackgroundElementImg';

const BackgroundElementBackground = ({
    src={finalImageURl},
    srcFallback=null,
    imgStyles,
    fallbackInUse,
    setFallback
}) => (
    <BackgroundElementImg
        cssClassImg='background-image'
        alt='Background' 
        src={src} 
        srcFallback={srcFallback}
        imgStyles={imgStyles}
        fallbackInUse={fallbackInUse}
        setFallback={setFallback}
    />
)


export default BackgroundElementBackground